import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsUserReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsUserReducer;
